import api from 'core/api';

// eslint-disable-next-line import/prefer-default-export
export const advertisings = () => api.get('/advertisings');
export const registration = (data) => api.post('/advertising/registration', data);
export const click = (data) => api.post('/advertising/click', data);
